// extracted by mini-css-extract-plugin
export var bar = "stylizations-module--bar--OSUyg";
export var button = "stylizations-module--button--gpb9g";
export var container = "stylizations-module--container--KzVIt";
export var error = "stylizations-module--error--xKcQ-";
export var icon = "stylizations-module--icon--nEZAD";
export var info = "stylizations-module--info--GEa9M";
export var list = "stylizations-module--list--lMncQ";
export var section = "stylizations-module--section--41e4B";
export var title = "stylizations-module--title--NNVhn";